import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { Dashboard } from './../layouts'
import {
    BaseTable,
    ActionUpdateButton
} from './../components'
import { pathJoin } from './../utils/helpers'

const styles = theme => ({
    //
})

class Resumes extends Component {
    constructor(props) {
        super(props)
        this.table = React.createRef()

        this.state = {
            title: 'Анкет',
            columns: [
                {
                    name: 'name',
                    title: 'Нэр'
                },
                {
                    name: 'parentName',
                    title: 'Эцгийн /эхийн/ нэр'
                },
                {
                    name: 'created',
                    title: 'Үүсгэсэн'
                },
                {
                    name: 'updated',
                    title: 'Шинэчилсэн'
                },
                {
                    getCellValue: ({ id }) => <ActionUpdateButton path={pathJoin('resumes', id)} />
                }
            ]
        }
    }
    onDelete = async () => {
        return await this.table.current.fetchData()
    }
    render() {
        const {
            title,
            columns
        } = this.state

        return (
            <Dashboard title={title}>
                <BaseTable
                    path="resumes"
                    columns={columns}
                    innerRef={this.table}
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(Resumes)
